import { IChartDetailing } from '../../../../../../../../constants/chartDetailing';
import { IDateFormatFromChartDetailing } from './interfaces';
import { TFunction } from 'i18next';

/**
 * Функция для получения формата даты в зависимости от выбранной детализации графика
 * @param chartDetailing детализация графика
 * @param isSeriesName флаг, для правильного отображения названия серии
 * @returns формат даты
 */
const getDateFormatByChartDetailing = (
    chartDetailing: IChartDetailing,
    isSeriesName: boolean = false,
    t: TFunction,
): IDateFormatFromChartDetailing => {
    const format: IDateFormatFromChartDetailing = {
        preset: 'DATE_MED',
        token: 'dd MMM yyyy',
    };
    switch (chartDetailing.id) {
        case '15MIN':
        case 'H':
            format.token = 'dd MMM yyyy, HH:mm';
            break;
        case 'D':
            format.token = isSeriesName ? 'dd MMM yyyy' : 'dd MMM yyyy (EEEE)';
            break;
        case 'W-MON':
            format.token = `WW ${t('wk')} yyyy`;
            break;
        case 'MS':
            format.token = 'MMMM yyyy';
        default:
            break;
    }
    return format;
};

export default getDateFormatByChartDetailing;
